import { store } from "../redux/store";
import { logout } from "../redux/userDucks";
import { pathHomePage } from "./constants";

// Cabecera de autorizacion con el token que devolvio el login.
export const getAuthorizationHeaders = () => {
  const { token } = store.getState().user;
  return { Authorization: `Bearer ${token}` };
};

// El backend responde 401 cuando el token falta, es invalido o ha caducado.
// En ese caso la sesion ya no sirve: se limpia y se vuelve al login.
export const handleUnauthorized = (error) => {
  if (error && error.response && error.response.status === 401) {
    store.dispatch(logout());
    if (window.location.pathname !== `${pathHomePage}/`) {
      window.location.replace(`${pathHomePage}/`);
    }
  }
};
